//
// Generated class VenueEvent
//

/// <reference path="VenueEvent_ManagedObject.ts" />

// What the event is: one entity holds every option, the kind only decides which screens and
// public pages it appears in, and it can be changed at any time (mirrors VenueEventKind in DualLinkDB)
enum VenueEventKind
{
    Generic = 0,
    Show    = 1,   // ticketed: music, football, a tasting — sold on the online events page
    Planned = 2,   // catering, wedding, birthday — planning, quotes and tasks
}

class VenueEvent extends VenueEvent_ManagedObject
{


    static kindName(kind:number):string {
        switch (kind) {
            case VenueEventKind.Show:    return MIOLocalizeString("EVENT_KIND_SHOW", "Show");
            case VenueEventKind.Planned: return MIOLocalizeString("EVENT_KIND_PLANNED", "Planned event");
            default:                     return MIOLocalizeString("EVENT_KIND_GENERIC", "Event");
        }
    }
}
